export default "__VITE_ASSET__DTeGAyzO__"